import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";

import CartaSocialBadge from "./carta_social_badge.component";
import AdmissionsBadge from "./admissions_badge.component";
import RequestModeBadge from "./request_mode_badge.component";
import PaymentStatusBadge from "./payment_status_badge.component";
import { EstablishmentPlanBadge } from "./establishment_plan_badge.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";

export class EstablishmentValenceCard extends React.Component {
  render() {
    const {
      establishmentValence,
      addEstablishmentValence,
      countAllAutoAddedEstablishments,
      countAutoNotSentEstablishments,
      countManualAddedEstablishments,
      countManualNotSentEstablishments,
      isNameFilterEnabled,
    } = this.props;
    const force_requests = establishmentValence.force_requests;
    const disabled_plan = establishmentValence.disable_access_to_requests;
    const disableButton =
      (!isNameFilterEnabled &&
        (countAllAutoAddedEstablishments === 0 ||
          countAllAutoAddedEstablishments === 1)) ||
      countAutoNotSentEstablishments > 2 ||
      countManualNotSentEstablishments > 2 ||
      (isNameFilterEnabled && countManualAddedEstablishments > 0) ||
      this.props.filters.proposed_price === 1 ||
      this.props.userRequest.message_from_stats === null;

    //logica antiga do botao
    //const disableButton = (nrAutoAddedEstablishments < 3 && (establishmentValence.preference_order < 4 - nrAutoAddedEstablishments)) || disabled_plan || force_requests;
    const blockedEstablishment =
      establishmentValence.limit_establishments_requests === 1;

    return (
      <Grid
        container
        alignItems="center"
        className={
          disabled_plan
            ? "valence-card-padding disable-requests"
            : (force_requests || blockedEstablishment
            ? "valence-card-padding force-requests"
               : "valence-card-padding")
        }
      >
        <Grid
          title={
            force_requests
              ? "Com potencial de angariação"
              : disabled_plan
              ? "Sem acesso a pedidos"
              : blockedEstablishment
              ? "Bloqueio de encaminhamentos ativo"
              : ""
          }
          item
          md={5}
        >
          <Tooltip
            title={
              "Concelho: " +
              establishmentValence.establishment.county.name +
              "/ Freguesia: " +
              establishmentValence.parish_name
            }
          >
            <span>{establishmentValence.establishment.name} </span>
          </Tooltip>
          {establishmentValence.closest_parish_gps_dist > 0 &&
            establishmentValence.mapa_gps_dist === 0 && (
              <Tooltip title="Distância à freguesia de ref. do pedido">
                <span style={{ fontSize: "14px", color: "#4682b4" }}>
                  {`(${Number(
                    establishmentValence.closest_parish_gps_dist
                  ).toFixed(2)}Km)`}
                </span>
              </Tooltip>
            )}
          {establishmentValence.mapa_gps_dist > 0 && (
            <Tooltip title="Distância ao marcador do mapa">
              <span style={{ fontSize: "14px", color: "#4682b4" }}>
                {`(${Number(establishmentValence.mapa_gps_dist).toFixed(2)}Km)`}
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item sm={1}>
          <Typography className="signs-span" variant="body2">
            <FontAwesomeIcon icon="euro-sign" />
            {establishmentValence.min_price}
          </Typography>
        </Grid>
        <Grid item sm={1}>
          <CartaSocialBadge
            cartaSocial={establishmentValence.in_social_charter}
          />
        </Grid>
        <Grid item sm={1}>
          <RequestModeBadge
            mode={establishmentValence.establishment.entity.request_mode}
          />
        </Grid>
        <Grid item sm={1}>
          <AdmissionsBadge
            admissions={establishmentValence.admitted}
            requests={establishmentValence.request_count}
          />
        </Grid>
        <Grid item sm={1}>
          <PaymentStatusBadge
            has_problems={
              establishmentValence.establishment.entity.has_payment_problems
            }
          />
        </Grid>
        <Grid item sm={1}>
          <EstablishmentPlanBadge plan={establishmentValence.plan} />
        </Grid>
        <Tooltip
          title={disableButton === true ? "Automático" : "Encaminhar"}
          item
          sm={1}
        >
          <Button
            onClick={() =>
              addEstablishmentValence(
                establishmentValence.id,
                establishmentValence.establishment.name,
                false,
                true
              )
            }
            disabled={disableButton}
          >
            <Icon
              fontSize="medium"
              className={
                !disableButton ? "normal-requests-btn" : "disabled-requests-btn"
              }
            >
              add_circle
            </Icon>
          </Button>
        </Tooltip>
      </Grid>
    );
  }
}
